<template>
    <div class="item-record-box">
        <div class="img-box">
            <img :src="imgUrl">
        </div>

        <div class="content-box">
            <div class="content-title">
                <span>{{productname}}</span>
            </div>

            <div class="content-description">
                <span>{{description}}</span>
            </div>

            <div>
                <div class="wholesale-box" v-if="null != wholesaleObj">
                    <div class="text-part">
                        <span tkey="批發價">{{i18n.tkey("lang_wholesale")}}</span>:&nbsp;
                        <span class="price-text">{{wholesaleObj.Cost}}&nbsp;{{wholesaleObj.Curr}}</span>
                    </div>

                    <div class="text-part">
                        <span tkey="最低購買量">{{i18n.tkey("lang_min_buy_num")}}</span>:&nbsp;
                        <span class="num-text">{{wholesaleObj.BiggerThan}}</span>
                    </div>

                    <div class="checkbox-part">
                        <el-checkbox size="large" :checked="productChecked" @change="clickSelectCallback" />
                    </div>
                </div>

                <div class="no-wholesale-text" v-if="null == wholesaleObj">
                    <span>{{i18n.tkey("lang_no_support_your_region")}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

    import {inject, computed, toRef, ref, onBeforeMount} from "vue";
    import myUtil from "@/util/util";
    import {useUserinfo} from "@/stores/userinfo";

    const props = defineProps(["obj"])
    const emits = defineEmits(["selectProduct"])

    const i18n = inject("i18n")
    const userInfoRef = toRef(useUserinfo())

    let companyObj = {}
    const wholesaleObj = ref(null)

    const productChecked = ref(false)

    const { getCompanyObj } = inject('quotationMain', { getCompanyObj: () => { return {} } })
    const { getSelectProductMap } = inject('quotationProductExhibition', { getSelectProductMap: () => { return {} } })

    const imgUrl = computed(() => {
        return myUtil.generateProductImg(props.obj)
    })

    const productname = computed(() => {
        let name = props.obj.productnamecn

        if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "en"){
            name = props.obj.productname
        }

        return name
    })

    const description = computed(() => {
        let text = props.obj.description2

        if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "en"){
            text = props.obj.description
        }

        return text
    })

    function getWholesaleObj(){
        let obj = null


        if (null != props.obj.ClientProSerQtyList){

            let allObj = null
            let countryObj = null

            for (let i=0; i<props.obj.ClientProSerQtyList.length; i++){
                const obj = props.obj.ClientProSerQtyList[i]

                if (obj.Country == "all"){
                    allObj = obj
                    continue
                }

                if (obj.Country == userInfoRef.value.country){
                    countryObj = obj
                    break
                }

            }

            if (allObj == null && countryObj == null){
                if (userInfoRef.value.country == companyObj.countrycode){
                    obj = {
                        BiggerThan: 1,
                        Country: "all",
                        Cost: props.obj.cost,
                        Curr: props.obj.curr,
                        CompanyCode: companyObj.acccompanycode,
                        ProductID: props.obj.productid,
                        ID: -1
                    }
                }

            }else{
                if (null != countryObj){
                    obj = countryObj
                }else if (null != allObj){
                    obj = allObj
                }
            }

        }

        wholesaleObj.value = obj
    }

    function clickSelectCallback(e){
        var obj = {}

        obj = Object.assign(obj, wholesaleObj.value)
        obj.mid = props.obj.id

        emits("selectProduct", e, obj)
    }

    function setCheckedFlag(){
        const map = getSelectProductMap()

        if (null != map[props.obj.id]){
            productChecked.value = true
        }

    }

    onBeforeMount(() => {
        companyObj = getCompanyObj()
        setCheckedFlag()
        getWholesaleObj()
    })

</script>

<style scoped>
    .item-record-box {
        display: flex;
        text-align: left;
    }

    .item-record-box .img-box {
        width: 80px;
        height: 80px;
    }

    .item-record-box .img-box img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        border: 1px #EBEEF5 solid;
        box-sizing: border-box;
    }

    .item-record-box .content-box {
        width: calc(100% - 80px);
        line-height: 2;
        box-sizing: border-box;
        padding-left: 5px;
        padding-right: 5px;
    }

    .item-record-box .content-box .content-title {
        font-size: 14px;
        color: #606266;
    }

    .item-record-box .content-box .content-description {
        font-size: 12px;
        color: #909399;
    }

    .no-wholesale-text {
        text-align: right;
        font-size: 12px;
        color: #666;
    }

    .wholesale-box {
        display: flex;
        margin-top: 10px;
    }

    .wholesale-box .text-part {
        width: calc(50% - 25px);
        font-size: 14px;
        color: #606266;
    }

    .wholesale-box .checkbox-part {
        width: 50px;
        text-align: right;
    }

    .price-text {
        color: #F56C6C;
        font-size: 1.1em;
    }

    .num-text {
        color: #409EFF;
        font-size: 1.1em;
    }
</style>